// v2.0.0 — Carte adresse virtuelle CIV-AI rendue dans le chat.
// Affiche le code CIV-XXX-YYYY-NNN en grand + texte complet + mini-map Leaflet.

import { useState } from "react";
import { MapContainer, TileLayer, Marker } from "react-leaflet";
import { toast } from "sonner";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

// Fix icônes Leaflet par défaut (cassées en webpack/CRA sans config).
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

export default function AdresseCard({ data }) {
  const [copied, setCopied] = useState(false);
  if (!data || !data.id_adresse_unique) return null;
  const lat = data.lat;
  const lng = data.lng;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(data.id_adresse_unique);
      setCopied(true);
      toast.success("Code copié ✓");
      setTimeout(() => setCopied(false), 2000);
    } catch (_) {
      toast.error("Copie impossible");
    }
  };

  return (
    <div className="civ-adresse-card" data-testid="adresse-card">
      <div className="civ-adresse-head">
        <span className="civ-adresse-pin">📍</span>
        <h3 className="civ-adresse-title">Mon Adresse CIV-AI</h3>
      </div>
      <div className="civ-adresse-code" data-testid="adresse-card-code">
        {data.id_adresse_unique}
      </div>
      <div className="civ-adresse-text" data-testid="adresse-card-text">
        {data.adresse_textuelle}
      </div>
      {data.metres_du_carrefour !== undefined && (
        <div className="civ-adresse-meta">
          📏 À <strong>{data.metres_du_carrefour}m</strong> du carrefour repère
        </div>
      )}
      {typeof lat === "number" && typeof lng === "number" && (
        <div className="civ-adresse-map" data-testid="adresse-card-map">
          <MapContainer
            center={[lat, lng]}
            zoom={16}
            scrollWheelZoom={false}
            dragging={false}
            style={{ width: "100%", height: 150, borderRadius: 8 }}
            attributionControl={false}
          >
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution='&copy; OpenStreetMap'
            />
            <Marker position={[lat, lng]} />
          </MapContainer>
        </div>
      )}
      <div className="civ-adresse-actions">
        <button
          type="button"
          className="civ-adresse-copy-btn"
          onClick={copy}
          data-testid="adresse-card-copy-btn"
        >
          {copied ? "✓ Copié" : "📋 Copier le code"}
        </button>
        <a
          href={`/addressing?focus=${encodeURIComponent(data.id_adresse_unique)}`}
          className="civ-adresse-open-btn"
          data-testid="adresse-card-open-btn"
        >
          🗺 Ouvrir la carte ↗
        </a>
      </div>
    </div>
  );
}
